import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Col,
  Container,
  Row,
  Table,
  Modal,
  Alert,
  Tabs,
  Tab,
  Badge,
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import WhatsAppAPI from "../../api/WhatsAppAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
// import Confirm from "../Confirm";
import Confirm from "../../Confirm";
import moment from "moment";
import SparkApi from "../../../api/SparkApi";

const InvoiceLineItem = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const contentRef = useRef();
  const [settings, setSettings] = useState(null);
  const [invoice, setInvoice] = useState({});
  const [company, setCompany] = useState({});
  const [allInvoiceData, setAllInvoiceData] = useState([]); //added By Yamini

  const fetchCompany = async (id) => {
    const companyResponse = await SparkApi.findCompanyWithUser(id);
    if (companyResponse.companyResult) {
      setCompany(companyResponse.companyResult[0]);
    } else {
      setCompany({});
    }
  };

  const fetchSetting = async (name) => {
    const settingResponse = await SparkApi.getSetting(name);
    if (settingResponse) {
      setSettings(settingResponse?.setting);
    } else {
      setSettings({});
    }
  };

  const fetchInvoice = async (id) => {
    const invoiceResponse = await SparkApi.getInvoiceById(id);
    if (invoiceResponse) {
      setAllInvoiceData(invoiceResponse);
      setInvoice(invoiceResponse[0]);
      fetchCompany(invoiceResponse[0]?.company_id);
    } else {
      setInvoice({});
    }
  };

  useEffect(() => {
    if (location.hasOwnProperty("pathname")) {
      invoice.id = location.pathname.split("/")[3];
    }
    if (props && props?.data && props.data.id) {
      invoice.id = props.data.id;
    }

    fetchInvoice(invoice.id);
    fetchSetting("GST");
  }, []);

  const handleCancel = () => {
    navigate("/company/" + invoice.company_id);
  };

  const handleMainTab = async (tabname) => {
    try {
      if (tabname === "Invoices") {
        // setInvoiceCheck(true);
        // setSelectedTab(tabname);
      }
    } catch (error) {
      //     
    }
  };

  const header = [
    {
      title: "Product",
      prop: "addon_name",
      isFilterable: true,
      cell: (row) => (
        <Link to={`/invoice/${row.id}`}>
          {row.addon_name ? row.addon_name : "Plan"}
        </Link>
      )
    },
    // { title: "Unit", prop: "addon_unit", isFilterable: true, cell: (row) => (
    //       <>
    //         {row.addon_unit ? row.addon_unit : "1"}
    //       </>
    //     ) },
    { title: "Quantity", prop: "inv_items_quantity", isFilterable: true },
    { title: "Amount", prop: "inv_items_amount", isFilterable: true, cell: (row) => `₹${Math.round(row.inv_items_amount)}` },
    {
      title: "Created Date",
      prop: "inv_items_createddate",
      isFilterable: true,
      cell: (row) =>
        row.inv_items_createddate
          ? moment(row.inv_items_createddate).format("DD-MM-YYYY")
          : "",
    },
    {
      title: "Status",
      prop: "status",
      isFilterable: true,
      cell: (row) => {
        var badgeColor;
        var value;
        if (row.status === "Complete") {
          badgeColor = "success";
          value = row.status;
        } else if (row.status === "Pending") {
          badgeColor = "danger";
          value =
            new Date() < new Date(row.payment_due_date) ? "Due" : "Over Due";
        } else if (row.status === "Cancel") {
          badgeColor = "warning";
          value = row.status;
        }
        return (
          <>
            <h5>
              <Badge bg={badgeColor} style={{ width: "80px", padding: "6px" }}>
                {value}
              </Badge>
            </h5>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Container className="mt-5">
        <Row className="mx-5 section-header">
          <Col lg={12} sm={12} xs={12}>
            <Row className="view-form-header align-items-center">
              <Col lg={8} sm={8} xs={8} className="">
                Invoice Details
              </Col>
              <Col lg={4} sm={4} xs={4} className="text-end">
                <Button
                  className="mx-2 btn-sm"
                  variant="light"
                  onClick={handleCancel}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Container className="mt-1">
        <Row className="mx-5 view-form">
          <Col lg={12} sm={12} xs={12}>
            <Row className="py-2 ibs-edit-form">
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Invoice No.</label>
                <span className="text-capitalize">
                  {invoice?.invoice_no ? invoice?.invoice_no : <>&nbsp;</>}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Invoice Date</label>
                <span className="text-capitalize">
                  {invoice?.invoice_date ? (
                    moment(invoice?.invoice_date).format("DD-MM-YYYY")
                  ) : (
                    <>&nbsp;</>
                  )}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Company Name</label>
                <span className="text-capitalize">
                  {company.company_name ? company.company_name : <>&nbsp;</>}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>User Name</label>
                <span className="text-capitalize">
                  {company?.firstname + " " + company?.lastname}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Admin Email</label>
                <span>{company?.email ? company?.email : <>&nbsp;</>}</span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Contact</label>
                <span>
                  {company?.whatsapp_number ? (
                    company?.whatsapp_number
                  ) : (
                    <>&nbsp;</>
                  )}
                </span>
              </Col>
              {/* Transaction Details */}
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Plan</label>
                <span>
                  {invoice?.plan_name ? invoice?.plan_name : <>&nbsp;</>}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>
                  Validity(
                  {invoice?.planname === "Free Trail" ? "in Days" : "in Months"}
                  )
                </label>
                <span className="text-capitalize">
                  {invoice?.validity ? invoice?.validity : <>&nbsp;</>}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Plan Validity Date</label>
                <span className="text-capitalize">
                  {moment(invoice?.start_date).format("DD-MM-YYYY")} — {moment(invoice?.end_date).format("DD-MM-YYYY")}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Total Amount</label>
                <span>
                  {allInvoiceData[0]?.total_amount ? (
                    `₹${Math.round(allInvoiceData[0]?.total_amount)}`
                  ) : (
                    <>&nbsp;</>
                  )}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Card bg="light" text="light" className="mx-5 mt-4">
          <Card.Header className="d-flex card-header-grey justify-content-between">
            <Tabs
              defaultActiveKey="Invoices"
              id="uncontrolled-tab-example"
              onSelect={(key) => handleMainTab(key)}
            >
              <Tab eventKey="Invoices" title="Invoices"></Tab>
            </Tabs>
          </Card.Header>
          <Card.Body>
            <Col lg={12} className="px-4 pb-4">
              {allInvoiceData ? (
                <DatatableWrapper
                  body={allInvoiceData}
                  headers={header}
                  paginationOptionsProps={{
                    initialState: {
                      rowsPerPage: 10,
                      options: [5, 10, 15, 20],
                    },
                  }}
                >
                  <Row className="mb-2 d-flex justify-content-start">
                    <Col
                      lg={3}
                      sm={6}
                      xs={6}
                      className="d-flex flex-col justify-content-start align-items-start"
                    >
                      <Filter />
                    </Col>
                    <Col
                      lg={5}
                      sm={6}
                      xs={6}
                      className="d-flex flex-col justify-content-start align-items-start"
                    ></Col>
                    <Col
                      lg={4}
                      sm={6}
                      xs={6}
                      className="d-flex flex-col justify-content-end align-items-end"
                    >
                      <Link to={"/invoice/generate/" + invoice.company_id}>
                        <Button
                          className="btn-sm"
                          variant="outline-primary"
                        >
                          Generate Invoice
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                  <Table
                    striped
                    className="related-list-table"
                    responsive="sm"
                  >
                    <TableHeader />
                    <TableBody />
                  </Table>

                  <Row className="mb-2">
                    <Col lg={6} sm={12} xs={12}>
                      <Pagination />
                    </Col>
                  </Row>
                </DatatableWrapper>
              ) : (
                <ShimmerTable row={10} col={8} />
              )}
            </Col>
          </Card.Body>
        </Card>
        <ToastContainer />
      </Container>
    </>
  );
};
export default InvoiceLineItem;
